angular.module('app').controller('SchoolsCtrl', function($controller, $scope) {
    "ngInject";

    var main = this;
    main.name = 'school';
    angular.extend(main, $controller('ListCtrl', {'$scope': $scope, 'main': main}));
    main.query.is_lead = false;
    main.eqFields.push({'op': 'eq', 'remoteName': 'is_lead', 'localName': 'is_lead'})
});